import PageHeader from "./PageHeader";

// Centered document shell for long-form brand & legal pages.
export function DocShell({ icon, eyebrow, title, subtitle, updated, pageTestId, children }) {
  return (
    <div data-testid={pageTestId} className="max-w-3xl mx-auto px-4 py-8 sm:py-12 w-full flex flex-col items-center">
      <PageHeader icon={icon} eyebrow={eyebrow} title={title} subtitle={subtitle} />
      {updated && (
        <p data-testid="doc-updated" className="font-mono text-xs text-foreground/50 mb-6 -mt-2">
          Last updated {updated}
        </p>
      )}
      <div className="w-full space-y-5">{children}</div>
    </div>
  );
}

// A centered white card that holds a section heading + left-aligned readable body.
export function DocCard({ heading, id, children, testId }) {
  return (
    <section
      id={id}
      data-testid={testId}
      className="w-full max-w-2xl mx-auto rounded-3xl bg-white border border-border/80 p-6 sm:p-8 shadow-sm text-left space-y-3">
      {heading && (
        <h2 className="font-serif text-xl sm:text-2xl font-semibold text-bronze text-center pb-1">
          {heading}
        </h2>
      )}
      <div className="space-y-3 text-sm sm:text-base text-foreground/85 leading-relaxed">
        {children}
      </div>
    </section>
  );
}

export default DocShell;
